export * from './textArea.component';
export * from './textAreaControl.model';
